export const EXCMCYCLICTASK_CREATE_RESET = 'EXCMCYCLICTASK_CREATE_RESET'
export const EXCMCYCLICTASK_CREATE_SET_CREATED = 'EXCMCYCLICTASK_CREATE_SET_CREATED'
export const EXCMCYCLICTASK_CREATE_SET_ERROR = 'EXCMCYCLICTASK_CREATE_SET_ERROR'
export const EXCMCYCLICTASK_CREATE_SET_VIOLATIONS = 'EXCMCYCLICTASK_CREATE_SET_VIOLATIONS'
export const EXCMCYCLICTASK_CREATE_TOGGLE_LOADING = 'EXCMCYCLICTASK_CREATE_TOGGLE_LOADING'
